import React from "react";
import { FormGroup } from "react-bootstrap";
import { reduxForm, Field, SubmissionError } from "redux-form";

import { Button } from "components";
import { LoginFormName, URLS, ValidationMessages } from "globalConstants";
import { getErrorMessage } from "helpers";
import { useCheckCredentialsMutation } from "queries";
import { requiredWithMessage } from "validators";

import FormInputGroup from "./formInputGroup";
import Policy from "./policy";


import styles from "./login.module.scss";

const UsernameForm = ({
	next,
	handleSubmit,
	submitting,
	setIsEmailUnique,
	setDomains,
	setAttempts,
}) => {
	const {
		mutateAsync: getCheckCredentials,
		isLoading: isLoadingCredentials,
	} = useCheckCredentialsMutation();

	const handleSubmitUsername = async ({ username }) => {
		if (username) {
			const {
				data: {
					is_valid,
					is_email_unique,
					email_update_attempts_skipped,
					whitelisted_email_domains,
				},
			} = await getCheckCredentials({
				username,
			});

			if (!is_valid) {
				throw new SubmissionError({
					username: getErrorMessage(
						ValidationMessages.InvalidUsername,
					),
				});
			}

			if (is_valid && is_email_unique) {
				setIsEmailUnique(true);
				return next();
			}

			if (is_valid && !is_email_unique) {
				setIsEmailUnique(false);
				setDomains(whitelisted_email_domains);
				setAttempts(email_update_attempts_skipped);
				return next();
			}
		}
	};

	return (
		<form onSubmit={handleSubmit(handleSubmitUsername)}>
			<Field
				component={FormInputGroup}
				label="Username"
				name="username"
				id="username"
				placeholder="Enter your username"
				autoFocus
				validate={requiredWithMessage("Username cannot be empty")}
			/>
			<Policy toPrivacy={URLS.toPrivacy} toTerms={URLS.toTerms} />
			<FormGroup className="col-md-12 text-center">
				<Button
					type="submit"
					disabled={submitting || isLoadingCredentials}
					className={styles.nextBtn}
					value="Next"
				/>
			</FormGroup>
		</form>
	);
};

export default reduxForm({
	form: LoginFormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: true,
})(UsernameForm);
